module.exports = __webpack_public_path__ + "assets/img/recruit3.324ffa21.png";